export function isMonthlyConsumptionInvoice(value: string): boolean {
    return value === 'Monthly Consumption Invoice';
}